"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _MediumOutlined = _interopRequireDefault(require("@ant-design/icons-svg/lib/asn/MediumOutlined"));
var _AntdIcon = _interopRequireDefault(require("../components/AntdIcon"));
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var MediumOutlined = function MediumOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
    ref: ref,
    icon: _MediumOutlined.default
  }));
};

/**![medium](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzNC43IDI3OS44bDYxLjMtNTguOVYyMDhINjgzLjdMNTMyLjQgNTg2LjQgMzYwLjMgMjA4SDEzNy43djEyLjlsNzEuNiA4Ni42YzcgNi40IDEwLjYgMTUuOCA5LjcgMjUuMlY2NzNjMi4yIDEyLjMtMS43IDI0LjgtMTAuMyAzMy43TDEyOCA4MDV2MTIuN2gyMjguNnYtMTIuOWwtODAuNi05OGEzOS45OSAzOS45OSAwIDAxLTExLjEtMzMuN1YzNzguN2wyMDAuNyA0MzkuMmgyMy4zbDE3Mi42LTQzOS4ydjM0OS45YzAgOS4yIDAgMTEuMS02IDE3LjJsLTYyLjEgNjAuM1Y4MTloMzAxLjJ2LTEyLjlsLTU5LjktNTguOWMtNS4yLTQtNy45LTEwLjctNi44LTE3LjJWMjk3YTE4LjEgMTguMSAwIDAxNi44LTE3LjJ6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/React.forwardRef(MediumOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'MediumOutlined';
}
var _default = exports.default = RefIcon;